import { render } from "./OnboardingDetail.vue?vue&type=template&id=24f7e587&scoped=true"
import script from "./OnboardingDetail.vue?vue&type=script&lang=js"
export * from "./OnboardingDetail.vue?vue&type=script&lang=js"

import "./OnboardingDetail.vue?vue&type=style&index=0&id=24f7e587&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f7e587"]])

export default __exports__